// src/theme/palette.js
// Ported from takso-poc/takso-reporting-ui/src/theme/palette.js — do not rename.
export const COLORS = {
  // Programs / Singles
  Programs: '#713264',
  Singles: '#816E94',
  'Linked singles': '#9E2E93',
  'Singles only': '#A395B1',
  'Account holder': '#B84FB2',
  Guest: '#CF84CA',

  // Status buckets – DB names
  Unapproved: '#EE7A00',
  Approved: '#50972C',
  Archived: '#1D3498',

  // Status buckets – UI labels (Phase 3)
  Development: '#EE7A00',
  Active: '#50972C',
  Completed: '#1D3498',

  // Output type buckets
  Infrastructure: '#4C6A9A',
  Developmental: '#0C95CD',
  Presentational: '#C0E3F0',

  // Outcome domains (Takso standard colours)
  Cultural: '#FFB500',
  Economic: '#7B60A8',
  Environmental: '#007868',
  Governance: '#194B00',
  Social: '#FFA28B',
};

export const DEFAULT_COLORS = [
  '#4B2142',
  '#74226C',
  '#A395B1',
  '#50972C',
  '#1D3498',
  '#EE7A00',
];

export const colorFor = (label, i = 0) =>
  COLORS[label] || DEFAULT_COLORS[i % DEFAULT_COLORS.length];

// --- Pick black/white text for best contrast on a background color ---
function parseColor(c) {
  if (typeof c !== 'string') throw new Error('bad color');
  // hex (#rgb or #rrggbb)
  if (c.startsWith('#')) {
    let hex = c.slice(1);
    if (hex.length === 3)
      hex = hex
        .split('')
        .map((h) => h + h)
        .join('');
    const num = parseInt(hex, 16);
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
  }
  // rgb(a)
  if (c.startsWith('rgb')) {
    const m = c.match(/\d+/g);
    if (!m) throw new Error('bad rgb');
    const [r, g, b] = m.map(Number);
    return { r, g, b };
  }
  throw new Error('unsupported color');
}

export function textOn(bg, light = '#ffffff', dark = '#111827') {
  try {
    const { r, g, b } = parseColor(bg);
    // YIQ luma heuristic
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 140 ? dark : light;
  } catch {
    return dark;
  }
}
